export default {"src":"/_next/static/media/notifications.mono.459978c9.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};